import { AuthGuard } from './core/auth.guard';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { MainComponent } from './main/main.component';
import { AuthComponent } from './auth/auth.component';
import { LoginComponent } from './auth/login/login.component';
import { VersionComponent } from './auth/version/version.component';
import { DiscoverComponent } from './main/discover/discover.component';
import { ResetComponent } from './auth/reset/reset.component';
import { InfluencerGroupsComponent } from './main/influencer-groups/influencer-groups.component';
import { GroupDetailsComponent } from './main/group-details/group-details.component';
import { InfluencerComponent } from './main/influencer/influencer.component';
import { PostOverviewComponent } from './main/post-overview/post-overview.component';
import { CampaignsAddComponent } from './main/campaigns-add/campaign-add.component';
import { CampaignsComponent } from './main/campaigns/campaigns.component';
import { CampaignsEditComponent } from './main/campaigns-add/campaign-edit.component';
import { AdminComponent } from './main/admin/admin.component';
import { MeasureComponent } from './main/measure/measure.component';
import { LoginGuard } from './core/login.guard';
import { PdfViewerComponent } from './main/pdf-viewer/pdf-viewer.component';
import { InfluencerDetailPdfViewerComponent } from './main/pdf-viewer/influencer-detail-pdf-viewer/influencer-detail-pdf-viewer.component';
import { PostOverviewPdfViewerComponent } from './main/pdf-viewer/post-overview-pdf-viewer/post-overview-pdf-viewer.component';
import { MeasurePdfViewerComponent } from './main/pdf-viewer/measure-pdf-viewer/measure-pdf-viewer.component';
import { PdfGuard } from './core/pdf.guard';
import { PdfDeactivateGuard } from './core/pdfDeactivate.guard';
import { PlatformSettingsComponent } from './main/admin/platform-settings/platform-settings.component';
import { ActivePages, Page } from './services/event-tracker/event-tracker.service';
import { LevelsGuard } from './core/levels.guard';
import { SignUpComponent } from './auth/sign-up/sign-up.component';
import { VerifyNewAccountComponent } from './auth/verify-new-account/verify-new-account.component';
import { ConfirmPasswordComponent } from './auth/confirm-password/confirm-password.component';
import { CampaignNewComponent } from './main/campaign-new/campaign-new.component';
// pages for influencer platform
import { InfluencerDetailsComponent } from './influencer-platform/influencer-details/influencer-details.component';
import { InfluencerGuard } from './core/influencer.guard';
import { InfluencerAuthComponent } from './influencer-auth/influencer-auth.component';
// influencer main
import { InfluencerMainComponent } from './influencer-main/influencer-main.component';
import { InfluencerSignUpComponent } from './influencer-auth/influencer-sign-up/influencer-sign-up.component';
import { InfluencerLoginComponent } from './influencer-auth/influencer-login/influencer-login.component';
import { InfluencerCampaignDetailComponent } from './influencer-platform/influencer-campaign-detail/influencer-campaign-detail.component';
import { InfluencerInboxComponent } from './main/influencer-inbox/influencer-inbox.component';
import { InfluencerSettingsComponent } from './influencer-platform/influencer-settings/influencer-settings.component';
import { InfluencerHomeComponent } from './main/influencer-home/influencer-home.component';
import { CampaignPdfViewerComponent } from './main/pdf-viewer/campaign-pdf-viewer/campaign-pdf-viewer.component';
import { CampaignGuard } from './core/campaign.guard';
import { ContactPermissionComponent } from './influencer-platform/contact-permission/contact-permission.component';
import { InfluencerListComponent } from './main/influencer-list/influencer-list.component';
import { AccountSettingComponent } from './main/account-setting/account-setting.component';
import { NotFoundPageComponent } from './mmi/not-found-page/not-found-page.component';
import { InfluencerReviewComponent } from './main/admin/influencer-review/influencer-review.component';
import { EmailSettingsComponent } from './main/email-settings/email-settings.component';
import { AdvertiserAppAuthGuard } from './core/advertiser-app-auth.guard';
import { InactiveAccountComponent } from './auth/inactive-account/inactive-account.component';
import { NonSsoAuthGuard } from './core/non-sso-auth.guard';
import { FbLoginFailComponent } from './fb-testing-page/fb-login-fail/fb-login-fail.component';
import { FbAuthSuccessDeligatorComponent } from './core/fb-auth-success-deligator/fb-auth-success-deligator.component';
import { InfluencerConnectionComponent } from './influencer-platform/influencer-connection/influencer-connection.component';
import { InfluencerAllSetComponent } from './influencer-platform/influencer-all-set/influencer-all-set.component';
import { ForwardComponent } from './core/forward/forward.component';
var ɵ0 = {
    permissions: {
        only: 'main_menu.enable_home',
        redirectTo: '/influencer/login'
    }
}, ɵ1 = { order: 1 }, ɵ2 = { order: 2 }, ɵ3 = { order: 3 }, ɵ4 = {
    permissions: {
        only: 'influencer_platform.enable_influencer_details',
        redirectTo: '/influencer/login'
    }
}, ɵ5 = {
    permissions: {
        only: 'influencer_platform.enable_influencer_details',
        redirectTo: '/influencer/login'
    },
    needToConfirm: true
}, ɵ6 = {
    permissions: {
        only: 'influencer_platform.enable_influencer_details',
        redirectTo: '/influencer/login'
    }
}, ɵ7 = {
    permissions: {
        only: 'influencer_platform.enable_influencer_campaigns',
        redirectTo: '/influencer/login'
    },
    onInfluencerPlatform: true,
}, ɵ8 = {
    onInfluencerPlatform: true
}, ɵ9 = {
    onInfluencerPlatform: true
}, ɵ10 = {
    permissions: {
        only: 'influencer_platform.enable_influencer_details',
        redirectTo: '/influencer/login'
    }
}, ɵ11 = {
    permissions: {
        only: 'main_menu.enable_discover',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.DISCOVER_TAB,
    segmentActivePage: ActivePages.DISCOVER
}, ɵ12 = {
    activeTab: 'posts',
    permissions: {
        only: 'main_menu.enable_discover',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.DISCOVER_TAB,
    segmentActivePage: ActivePages.DISCOVER
}, ɵ13 = {
    activeTab: 'influencers',
    permissions: {
        only: 'main_menu.enable_discover',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.DISCOVER_TAB,
    segmentActivePage: ActivePages.DISCOVER
}, ɵ14 = {
    permissions: {
        only: 'main_menu.enable_discover',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.INFLUENCER_TAB,
    segmentActivePage: ActivePages.GROUP_OVERVIEW
}, ɵ15 = {
    isRecentlyVisitedInfluencerGroup: true
}, ɵ16 = {
    permissions: {
        only: 'main_menu.enable_discover',
        redirectTo: '/404'
    }
}, ɵ17 = { order: 1 }, ɵ18 = { order: 2 }, ɵ19 = { order: 3 }, ɵ20 = { order: 4 }, ɵ21 = {
    order: 5,
    levels: ['Premium', 'Enterprise']
}, ɵ22 = {
    permissions: {
        only: 'main_menu.enable_home',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.INFLUENCER_TAB,
    segmentActivePage: ActivePages.INFLUENCER_DETAILS
}, ɵ23 = {
    permissions: {
        only: 'main_menu.enable_home',
        redirectTo: '/404'
    }
}, ɵ24 = {
    permissions: {
        only: 'user_menu.enable_admin',
        redirectTo: '/login'
    }
}, ɵ25 = { activeTab: 'user-settings' }, ɵ26 = {
    activeTab: 'billing',
    segmentItem: Page.INFLUENCER_TAB,
    segmentActivePage: ActivePages.INFLUENCER_DETAILS
}, ɵ27 = {
    permissions: {
        only: 'main_menu.enable_home',
        redirectTo: '/login'
    }
}, ɵ28 = {
    segmentActivePage: ActivePages.CAMPAIGN_HISTORY,
    isCampaignHistory: true
}, ɵ29 = {
    segmentActivePage: ActivePages.CAMPAIGN_OVERVIEW
}, ɵ30 = {
    permissions: {
        only: 'main_menu.enable_campaigns',
        redirectTo: '/404'
    },
    levels: ['Free', 'Basic', 'Premium', 'Enterprise'],
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.CAMPAIGN_TAB,
    segmentActivePage: ActivePages.CAMPAIGN_OVERVIEW
}, ɵ31 = {
    permissions: {
        only: 'main_menu.enable_campaigns',
        redirectTo: '/404'
    },
    levels: ['Premium', 'Enterprise']
}, ɵ32 = {
    permissions: {
        only: 'main_menu.enable_campaigns',
        redirectTo: '/404'
    },
    levels: ['Premium', 'Enterprise']
}, ɵ33 = {
    permissions: {
        only: 'main_menu.enable_campaigns',
        redirectTo: '/404'
    },
    levels: ['Free', 'Basic', 'Premium', 'Enterprise']
}, ɵ34 = {
    permissions: {
        only: 'main_menu.enable_campaigns',
        redirectTo: '/404'
    },
    levels: ['Free', 'Basic', 'Premium', 'Enterprise']
}, ɵ35 = {
    permissions: {
        only: 'main_menu.enable_measure',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.MEASURE_TAB,
    segmentActivePage: ActivePages.MEASURE
}, ɵ36 = {
    permissions: {
        only: 'main_menu.enable_measure',
        redirectTo: '/404'
    },
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.MEASURE_TAB,
    segmentActivePage: ActivePages.MEASURE
}, ɵ37 = {
    permissions: {
        only: 'main_menu.enable_home',
        redirectTo: '/404'
    }
}, ɵ38 = {}, ɵ39 = {
    permissions: {
        only: 'user_menu.enable_admin',
        redirectTo: '/login'
    }
}, ɵ40 = {
    permissions: {
        only: 'main_menu.enable_inbox',
        redirectTo: '/404'
    },
    levels: ['Premium', 'Enterprise'],
    // use for Segment Analytics and Mixpannel. Refer: https://segment.com/
    segmentItem: Page.INBOX_TAB,
    segmentActivePage: ActivePages.INBOX
};
var appRoutes = [
    {
        path: '',
        component: AuthComponent,
        children: [
            { path: 'reset-password', component: ResetComponent, canActivate: [LoginGuard] },
            { path: 'resetPassword/:hashKey', component: ConfirmPasswordComponent, canActivate: [LoginGuard] },
            { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
            { path: 'verify', component: VerifyNewAccountComponent },
            // default public route is login
            { path: '', component: ForwardComponent, pathMatch: 'full' }
        ]
    },
    {
        path: '404',
        component: NotFoundPageComponent
    },
    {
        path: 'version',
        component: VersionComponent
    },
    {
        path: 'invite/welcome/:hashKey',
        component: SignUpComponent,
        canActivate: [LoginGuard]
    },
    {
        path: 'fb-auth-error',
        component: FbLoginFailComponent,
    },
    {
        path: 'fb-auth-success',
        component: FbAuthSuccessDeligatorComponent,
    },
    { path: 'influencer/contact-permission',
        component: InfluencerConnectionComponent
    },
    { path: 'user/all-set',
        component: InfluencerAllSetComponent
    },
    { path: 'email-settings',
        component: EmailSettingsComponent
    },
    {
        path: '',
        component: InfluencerAuthComponent,
        children: [
            { path: 'influencer/sign-up', component: InfluencerSignUpComponent, canActivate: [LoginGuard] },
            { path: 'influencer/login', component: InfluencerLoginComponent, canActivate: [LoginGuard] },
        ]
    },
    {
        path: '',
        component: InfluencerMainComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'dashboard',
                canActivate: [InfluencerGuard, NgxPermissionsGuard],
                data: ɵ0,
                children: [
                    {
                        path: 'home',
                        component: InfluencerHomeComponent
                    },
                    {
                        path: 'details',
                        children: [
                            { path: 'overview', component: InfluencerDetailsComponent, data: ɵ1 },
                            { path: 'insight', component: InfluencerDetailsComponent, data: ɵ2 },
                            { path: 'demographics', component: InfluencerDetailsComponent, data: ɵ3 },
                            { path: '', redirectTo: 'insight', pathMatch: 'full' }
                        ],
                        canActivate: [NgxPermissionsGuard],
                        data: ɵ4
                    },
                    {
                        path: 'settings',
                        component: InfluencerSettingsComponent
                    },
                    {
                        path: 'inbox',
                        component: InfluencerInboxComponent,
                        canActivate: [NgxPermissionsGuard],
                    },
                    {
                        path: 'campaigns/:campaignId/new',
                        component: CampaignNewComponent,
                        canActivate: [CampaignGuard, NgxPermissionsGuard],
                        data: ɵ5
                    },
                    {
                        path: 'campaigns/:campaignId/active',
                        component: InfluencerCampaignDetailComponent,
                        canActivate: [CampaignGuard, NgxPermissionsGuard],
                        data: ɵ6
                    },
                    {
                        path: 'campaigns',
                        canActivate: [CampaignGuard, NgxPermissionsGuard],
                        component: CampaignsComponent,
                        data: ɵ7
                    },
                    {
                        path: 'post/:urlHash',
                        component: PostOverviewComponent,
                        canActivate: [NgxPermissionsGuard],
                        data: ɵ8
                    },
                    {
                        path: 'contact-permission',
                        component: ContactPermissionComponent,
                        canActivate: [NgxPermissionsGuard],
                        data: ɵ9
                    },
                ]
            },
            {
                path: 'pdf/campaign/:campaignInfluencerId',
                component: CampaignPdfViewerComponent,
                canActivate: [InfluencerGuard, PdfGuard, NgxPermissionsGuard],
                canDeactivate: [PdfDeactivateGuard],
                data: ɵ10
            }
        ]
    },
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AdvertiserAppAuthGuard],
        children: [
            {
                path: 'discover',
                component: DiscoverComponent,
                canActivate: [NgxPermissionsGuard],
                data: ɵ11
            },
            {
                path: 'discover/posts',
                component: DiscoverComponent,
                canActivate: [NgxPermissionsGuard],
                data: ɵ12
            },
            {
                path: 'discover/influencers',
                component: DiscoverComponent,
                canActivate: [NgxPermissionsGuard],
                data: ɵ13
            },
            {
                path: 'groups',
                component: InfluencerGroupsComponent,
                canActivate: [NgxPermissionsGuard],
                data: ɵ14
            },
            {
                path: 'groups',
                children: [
                    { path: 'monthly-visit',
                        component: GroupDetailsComponent,
                        data: ɵ15
                    },
                    { path: ':influencer_group_id', component: GroupDetailsComponent }
                ],
                canActivate: [NgxPermissionsGuard],
                data: ɵ16
            },
            {
                path: 'influencer/:id',
                children: [
                    { path: 'overview', component: InfluencerComponent, data: ɵ17 },
                    { path: 'insight', component: InfluencerComponent, data: ɵ18 },
                    { path: 'demographics', component: InfluencerComponent, data: ɵ19 },
                    { path: 'activity', component: InfluencerComponent, data: ɵ20 },
                    { path: 'campaign',
                        canActivate: [LevelsGuard],
                        component: InfluencerComponent,
                        data: ɵ21
                    },
                    { path: '', redirectTo: 'overview', pathMatch: 'full' }
                ],
                canActivate: [NgxPermissionsGuard],
                data: ɵ22
            },
            {
                path: 'post',
                component: PostOverviewComponent,
                canActivate: [NgxPermissionsGuard],
                data: ɵ23
            },
            { path: 'framed/admin',
                component: AdminComponent,
                canActivate: [NonSsoAuthGuard, NgxPermissionsGuard],
                data: ɵ24
            },
            { path: 'account-settings',
                children: [
                    { path: 'user-settings', component: AccountSettingComponent, data: ɵ25 },
                    { path: 'billing',
                        component: AccountSettingComponent,
                        data: ɵ26
                    },
                    { path: '', redirectTo: 'user-settings', pathMatch: 'full' }
                ],
                canActivate: [NonSsoAuthGuard, NgxPermissionsGuard],
                data: ɵ27
            },
            {
                path: 'campaigns',
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                children: [
                    {
                        path: 'history',
                        component: CampaignsComponent,
                        data: ɵ28
                    },
                    {
                        path: '',
                        component: CampaignsComponent,
                        pathMatch: 'full',
                        data: ɵ29
                    }
                ],
                data: ɵ30
            },
            {
                path: 'campaigns-add',
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                component: CampaignsAddComponent,
                data: ɵ31
            },
            {
                path: 'campaigns-add/:tab-key',
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                component: CampaignsAddComponent,
                data: ɵ32
            },
            {
                path: 'campaigns/:id',
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                children: [
                    {
                        path: 'influencer-list',
                        component: InfluencerListComponent,
                    },
                    {
                        path: '',
                        component: CampaignsEditComponent,
                    },
                ],
                data: ɵ33
            },
            {
                path: 'campaigns/:id/:tab-key',
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                component: CampaignsEditComponent,
                data: ɵ34
            },
            {
                path: 'measure',
                canActivate: [NgxPermissionsGuard],
                component: MeasureComponent,
                data: ɵ35
            },
            {
                path: 'measure/:campaign_id',
                canActivate: [NgxPermissionsGuard],
                component: MeasureComponent,
                data: ɵ36
            },
            {
                path: 'pdf',
                component: PdfViewerComponent,
                canActivate: [PdfGuard, NgxPermissionsGuard],
                canDeactivate: [PdfDeactivateGuard],
                children: [
                    { path: 'influencer/:id', component: InfluencerDetailPdfViewerComponent },
                    { path: 'post', component: PostOverviewPdfViewerComponent },
                    { path: 'measure', component: MeasurePdfViewerComponent }
                ],
                data: ɵ37,
            },
            {
                path: 'admin/platform-settings',
                component: PlatformSettingsComponent,
                canActivate: [NonSsoAuthGuard],
                data: ɵ38
            },
            {
                path: 'admin/influencer-review',
                component: InfluencerReviewComponent,
                canActivate: [NonSsoAuthGuard, NgxPermissionsGuard],
                data: ɵ39
            },
            {
                path: 'inbox',
                component: InfluencerInboxComponent,
                canActivate: [NgxPermissionsGuard, LevelsGuard],
                data: ɵ40
            },
            {
                path: 'inactive-account',
                component: InactiveAccountComponent,
            },
            { path: '', redirectTo: '/discover', pathMatch: 'full' }
        ]
    },
    { path: '', redirectTo: '/discover', pathMatch: 'full' },
    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];
var AppRouteModule = /** @class */ (function () {
    function AppRouteModule() {
    }
    return AppRouteModule;
}());
export { AppRouteModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ40 };



// WEBPACK FOOTER //
// ./src/app/app.route.module.ts.pre-build-optimizer.js